/**
 * Datos del perfil que se usan en varias vistas: cuáles son obligatorios y cómo se escribe la dirección.
 */

/** Lleno de verdad: las cuentas nuevas guardan 0 en el teléfono y en el número de documento (Google). */
export function datoLleno(valor) {
    if (valor === undefined || valor === null || valor === 0) return false;
    const texto = String(valor).trim();
    return texto !== "" && texto !== "0";
}

/** Solo números, de 7 a 15 dígitos: fijos y celulares de Colombia, y de otros países. */
export function telefonoValido(telefono) {
    return /^\d{7,15}$/.test(String(telefono === undefined || telefono === null ? "" : telefono).trim());
}

/**
 * Perfil completo: los 10 datos que pide el equipo, en el orden del formulario. Sin ellos algunas secciones
 * no se abren (validarDatosUsuario en el store, que usa el router) y Mi Perfil avisa cuáles faltan.
 * El backend tiene su propia lista para el «perfil completo» (functions/src/modules/usuarios/hitos-crm.service.js):
 * si cambian aquí, cambiarlos allá.
 */
export const DATOS_OBLIGATORIOS = [
    { nombre: "nombres", valor: (usuario) => datoLleno(usuario.nombre) },
    { nombre: "apellidos", valor: (usuario) => datoLleno(usuario.apellido) },
    { nombre: "tipo de documento", valor: (usuario) => datoLleno(usuario.documento && usuario.documento.tipo) },
    { nombre: "número de documento", valor: (usuario) => datoLleno(usuario.documento && usuario.documento.numero) },
    { nombre: "fecha de nacimiento", valor: (usuario) => datoLleno(usuario.fechaNacimiento) },
    { nombre: "teléfono", valor: (usuario) => telefonoValido(usuario.telefono) },
    { nombre: "género", valor: (usuario) => datoLleno(usuario.genero) },
    { nombre: "país", valor: (usuario) => datoLleno(usuario.ubicacion && usuario.ubicacion.pais) },
    { nombre: "departamento", valor: (usuario) => datoLleno(usuario.ubicacion && usuario.ubicacion.departamento) },
    { nombre: "ciudad", valor: (usuario) => datoLleno(usuario.ubicacion && usuario.ubicacion.ciudad) },
];

/**
 * @param {Object} usuario - Documento de riskmann_usuarios.
 * @returns {string[]} Los nombres de los datos obligatorios que faltan, en el orden del formulario.
 */
export function datosFaltantes(usuario) {
    return DATOS_OBLIGATORIOS.filter((dato) => !dato.valor(usuario || {})).map((dato) => dato.nombre);
}

/**
 * «Fecha de nacimiento, teléfono y género»: la lista para leer, con la primera letra en mayúscula.
 * @param {string[]} nombres
 * @returns {string}
 */
export function unirConY(nombres) {
    const lista = (nombres || []).slice();
    const ultimo = lista.pop();
    const texto = lista.length ? `${lista.join(", ")} y ${ultimo}` : ultimo || "";
    return texto.charAt(0).toUpperCase() + texto.slice(1);
}

/**
 * «Calle 20A # 28-76», como la arman Openpay y la facturación de Planes. Sin el número de la vía, "".
 * @param {{tipo?: string, calle?: string, numero?: {campo1?: number, campo2?: number}}} direccion
 * @returns {string}
 */
export function armarDireccion(direccion) {
    const { tipo, calle, numero } = direccion || {};
    if (!calle) return "";
    let texto = `${tipo === "Via" ? "Vía" : tipo || ""} ${String(calle).toUpperCase()}`.trim();
    if (numero && numero.campo1) {
        texto += ` # ${numero.campo1}`;
        if (numero.campo2) texto += `-${numero.campo2}`;
    }
    return texto;
}
